module.exports = __webpack_public_path__ + "img/reason_img3.3d94f6d1.png";